'use client'
import { __awaiter } from '../../_virtual/_tslib.js';
import { isMobile } from '@dynamic-labs/utils';
import StarknetWalletConnector from '../starknetWalletConnector.js';

class Braavos extends StarknetWalletConnector {
    constructor(opts) {
        super('Braavos', 'braavos', opts);
        this.overrideKey = 'braavos';
    }
    getAddress() {
        const _super = Object.create(null, {
            getAddress: { get: () => super.getAddress }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isInstalledOnBrowser()) {
                return _super.getAddress.call(this);
            }
            /**
             * todo (1): update universal link with "https://starknet.app.link/" once it will be released.
             * todo (2): understand if we really want to avoid using "starknet-deeplink" library.
             */
            const url = window.location.toString().replace(/http(s)?:\/\//, '');
            const targetUrl = `starknet://dapp/${url}`;
            if (isMobile()) {
                window.location.assign(targetUrl);
            }
            return Promise.resolve(undefined);
        });
    }
}

export { Braavos };
